// extracted by mini-css-extract-plugin
export default {"productTable":"productlist_productTable__cPOOr","searchAddBlock":"productlist_searchAddBlock__5WuQ8"};